import { AxiosError } from 'axios';
import type { ApiErrorBody } from '../types';

/** Extracts a human-readable message from an API error response. */
export function extractApiError(err: unknown): string {
  if (err instanceof AxiosError && err.response?.data) {
    const body = err.response.data as ApiErrorBody;
    if (body?.error?.message) {
      const details = body.error.details?.map((d) => `${d.field ?? ''} ${d.message}`.trim()).join('; ');
      return details ? `${body.error.message}: ${details}` : body.error.message;
    }
  }
  return 'An unexpected error occurred';
}
